import {initWebComponent} from "@/helpers/web-component-helper";
import {setActiveFilter} from "@/helpers/filter/filter-helper";
import {
    getBySelector,
    hideElementsBySelector,
    removeClassBySelector,
    showElementsBySelector
} from "@/helpers/element-helper";
import {removeAllActiveClasses} from "@/helpers/layer-menu-helper";
import {getBranchItemByBookmarkPresentationID} from "@/helpers/tree-helper";
import {closeInfoMenu} from "@/helpers/layer/info/layer-info-helper";



export class LayerMenuButtonFilterComponent extends HTMLElement{
    constructor(){
        super();

        const bookmarkPresentationID = this.getAttribute('data-bookmark-presentation-id')
        const presentationID = this.getAttribute('data-presentation-id')
        const formID = this.getAttribute('data-form-id')
        let branchID = this.getAttribute('data-bookmark-presentation-id')

        const branchItem = getBranchItemByBookmarkPresentationID(bookmarkPresentationID)
        let filterFormNames = []

        if(branchItem.filter_forms) {
            branchItem.filter_forms.map((filterForm) => {
                if(filterForm.form) {
                    filterFormNames.push(filterForm.form.Name)
                }
            })

            branchID = undefined
        } else {
            branchItem.branch.map((branch) => {
                branch.filter_forms.map((filterForm) => {
                    if(filterForm.form) {
                        filterFormNames.push(filterForm.form.Name)
                    }
                })
            })
        }


        const template = document.createElement('template');
        template.innerHTML = `<button title="Filter op: ${filterFormNames.join(', ')}" class="btn btn-sm borderless icon-btn text-transform-none btn-filter" href="#">
<span class="fa fa-filter"></span></button>`;


        initWebComponent(this, template)

        this.addEventListener('click', (event) => {
            const button = this.querySelector('button')
            if(button.classList.contains('active')) {
                closeInfoMenu('layer-info-filter')

                showElementsBySelector('#btnShowFilterLayers')
            } else {
                removeAllActiveClasses()
                removeClassBySelector('.btn-filter', 'active')
                button.classList.add('active')
                setActiveFilter(bookmarkPresentationID, presentationID, undefined, undefined, undefined, branchID)

                hideElementsBySelector('#btnShowFilterLayers')
            }
        })
    }
}
